var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 4.66667L12.8332 7M12.8332 7L10.4998 9.33333M12.8332 7H5.24984M8.74984 2.45236C8.00623 2.00566 7.1429 1.75 6.22206 1.75C3.42995 1.75 1.1665 4.1005 1.1665 7C1.1665 9.89949 3.42995 12.25 6.22206 12.25C7.1429 12.25 8.00623 11.9943 8.74984 11.5476",
    stroke: "#777C80",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/log out.489a73188425c3441268ccb447008910.svg";
export { ForwardRef as ReactComponent };